<template>
  <div class="white-background-wrap">
    <div class="about">
      <h2 class="section-header">About Me</h2>
      <p>Hey guys! I'm Lowco. I stream full-time on Twitch with a focus on community, good vibes, and silly fails. I've been streaming since May 2014 with a primary focus on gaming-related content. Check out my website to learn more about what I do!</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../variables.scss';
.about{
  padding: $home-section-padding;
  max-width: 600px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// About.vue?3c584d90